class PayOutRequest {
  static create = {
    payOutAmount: null,
    payOutCustomerId: null
  };
}

export default PayOutRequest;
